// Filer RDO code for BIR DAT (SAWT) exports — BUG-7.
//
// The client's RDO lives on AccountingClient.rdoCode (required by the schema).
// A missing RDO must block the export, never be replaced by a placeholder
// such as '000': a placeholder files the return under a non-existent RDO.
//
// Presence is the only check. Some RDO codes carry a letter suffix
// (e.g. 021A), so a digits-only rule would block valid clients.

/** Trimmed RDO code, or null when none is stored. Callers must treat null as blocking. */
export function filerRdoCode(client) {
  const rdo = String(client?.rdoCode ?? '').trim();
  return rdo || null;
}

export function missingRdoMessage(clientName) {
  const who = String(clientName || '').trim() || 'this client';
  return `RDO code is missing for ${who}. Set the RDO code on the client profile, then export again.`;
}
